module.exports = __webpack_public_path__ + "img/ArgIslan2.77fbc065.jpg";